import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import api from "api";
import { useAuth } from "features/auth/fabric";


export const useQueryStart = () => useSuspenseQuery({
	queryKey: ["start"],
	queryFn: api.start.get,
	staleTime: Infinity
});

export const useQueryLog = () => {
	const auth = useAuth();
	const start = useQueryStart();
	return useQuery({
		queryKey: ["log"],
		queryFn: () => api.log.app({ path: location.pathname, userId: start.data.user?.id, device: auth.device }),
		enabled: !!auth.device && !!start.data
	});
};